// baseVisibility.js
//
// Canonical base visibility helpers (Chat v1).

export const BASE_VISIBILITY = Object.freeze({
  PRIVATE: 'private',
  PUBLIC: 'public',
});

/**
 * Normalizes a base visibility value to private | public.
 *
 * @param {unknown} value - Raw visibility from client or Firestore.
 * @returns {'private'|'public'} Canonical visibility.
 */
export function normalizeBaseVisibility(value) {
  return String(value || '').trim().toLowerCase() === BASE_VISIBILITY.PUBLIC
    ? BASE_VISIBILITY.PUBLIC
    : BASE_VISIBILITY.PRIVATE;
}

/**
 * Returns whether a base is public for Chat.
 *
 * @param {object|null|undefined} base - Base / base row.
 * @returns {boolean} True when visibility is public.
 */
export function isPublicBase(base) {
  return normalizeBaseVisibility(base?.visibility) === BASE_VISIBILITY.PUBLIC;
}
